/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{If as e,glsl as a}from"../shaderModules/glsl.js";function r(e){e.varyings.add("linearDepth","float",{invariant:!0})}function t(t,i){i&&r(t),t.vertex.code.add(a`
    void forwardLinearDepth(float _linearDepth) { ${e(i,"linearDepth = _linearDepth;")} }
  `)}export{t as ForwardLinearDepth,r as addLinearDepth};
